(function () {
      const breakpoint = 768;
      const section = document.querySelector('#references-grid-section');
      if (!section) return;

      const moveImages = () => {
        const cards = section.querySelectorAll('.js-ref-card');

        cards.forEach(card => {
          const image = card.querySelector('.js-ref-image');
          const slotMobile = card.querySelector('.js-image-slot-mobile');
          const slotDesktop = card.querySelector('.js-image-slot-desktop');

          if (!image || !slotMobile || !slotDesktop) return;

          if (window.innerWidth < breakpoint) {
            if (!slotMobile.contains(image)) slotMobile.appendChild(image);
          } else {
            if (!slotDesktop.contains(image)) slotDesktop.appendChild(image);
          }
        });
      };

      const initAjaxPagination = () => {
        const pag = section.querySelector('.js-ref-pagination');
        if (!pag) return;

        pag.addEventListener('click', async (e) => {
          const link = e.target.closest('a');
          if (!link) return;

          e.preventDefault();

          const url = link.href;
          const wrapper = section.querySelector('#references-grid-wrapper');
          if (!wrapper) return;

          wrapper.classList.add('is-loading');

          try {
            const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            const html = await res.text();

            const temp = document.createElement('div');
            temp.innerHTML = html;

            const newWrapper = temp.querySelector('#references-grid-wrapper');
            if (!newWrapper) {
              window.location.href = url; 
              return;
            }

            wrapper.innerHTML = newWrapper.innerHTML;

            moveImages();
            initAjaxPagination();

            window.history.pushState({}, '', url);

            section.scrollIntoView({ behavior: 'smooth', block: 'start' });

          } catch (err) {
            window.location.href = url;
            console.error("Load more error:", e);
          } finally {
            wrapper.classList.remove('is-loading');
          }
        });
      };

      window.addEventListener('DOMContentLoaded', () => {
        moveImages();
        initAjaxPagination();
      });
      window.addEventListener('resize', moveImages);

    })();